// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const USER_STROLLERS_DELETE_CONFIRM = "Opravdu chce\u0161 smazat ko\u010d\u00e1rek ze sv\u00e9ho profilu?";
